import {Attachment} from '../types'

export const getUniqueAttachments = <TId extends string | number = number>(
  attachments: Attachment<TId>[] | undefined,
  maxAllowedFiles: number
): Attachment<TId>[] => {
  return attachments
    ? [...new Map(attachments.map((o) => [o.fileName, o])).values()].slice(0, maxAllowedFiles)
    : []
}
